import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../style/Login.css'; // Will create this file
import logo from '../assets/images/teteklogo-removebg-preview.png';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); // Clear previous errors

        try {
            const response = await axios.post('https://assessment.tetekniqx.com/api/admin/login/', { // Assuming Django runs on 8000
                email,
                password,
            });

            if (response.status === 200) {
                // Assuming successful login returns a message or token
                console.log('Login successful:', response.data);
                // Store token or user info if provided in response. Currently, just navigating.
                localStorage.setItem('isAdminLoggedIn', 'true'); // Simple flag for now
                navigate('/admin'); // Redirect to admin page
            }
        } catch (err) {
            console.error('Login failed:', err);
            setError(err.response?.data?.error || 'Login failed. Please check your credentials.');
        }
    };

    return (
        <div className="login-container">
            <form className="login-form" onSubmit={handleSubmit}>
                <div style={{ textAlign: "center", marginBottom: "1rem" }}>
                    <img src={logo} alt="Logo" style={{ height: "45px", objectFit: "contain" }} />
                </div>
                <h2>Admin Login</h2>
                {error && <p className="error-message">{error}</p>}
                <div className="form-group">
                    <label htmlFor="email">Email:</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password">Password:</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <button type="submit" className="login-button">Login</button>
            </form>
        </div>
    );
}

export default Login;
